const basUrl = 'http://cjxy.imtmeta.com/'
// const basUrl = 'http://192 .168.1.4'
// const basUrl = 'http://gs.com'

export default {
    basUrl
}